module.exports = __webpack_public_path__ + "static/img/banner_bg.2bf8625.png";